module.exports = __webpack_public_path__ + "static/media/vacuum-cleaner.a03441f3.svg";